import { useInstallPrompt } from '../hooks/useInstallPrompt';

export function InstallBanner() {
  const { showBanner, showIOSGuide, install, dismiss } = useInstallPrompt();

  if (!showBanner) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[55]"
      style={{ animation: 'slideUp 0.3s ease-out' }}
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
      <div className="bg-white border-t border-gray-200 shadow-lg px-4 py-4">
        <div className="flex items-center gap-3">
          <div className="flex-shrink-0 w-10 h-10 bg-blue-600 rounded-control flex items-center justify-center">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
            </svg>
          </div>
          <div className="flex-1 min-w-0">
            {showIOSGuide ? (
              <p className="text-sm text-gray-800">
                홈 화면에 추가하려면 공유(
                <svg className="inline w-4 h-4 text-blue-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
                  <polyline points="16 6 12 2 8 6" />
                  <line x1="12" y1="2" x2="12" y2="15" />
                </svg>
                ) 버튼을 탭하세요
              </p>
            ) : (
              <p className="text-sm text-gray-800">SafetyHub 앱을 설치하시겠습니까?</p>
            )}
          </div>
          {showIOSGuide ? (
            <button
              onClick={dismiss}
              className="flex-shrink-0 px-3 py-1.5 text-sm font-medium text-blue-600 border border-blue-600 rounded-control"
            >
              확인
            </button>
          ) : (
            <div className="flex-shrink-0 flex gap-2">
              <button
                onClick={install}
                className="px-3 py-1.5 text-sm font-medium text-white rounded-control"
                style={{ backgroundColor: '#2563eb' }}
              >
                설치
              </button>
              <button
                onClick={dismiss}
                className="px-3 py-1.5 text-sm font-medium text-gray-600 border border-gray-300 rounded-control"
              >
                나중에
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
